import React from "react";
import { FormActions } from "../app";
import { EmployeeFormTabs } from "./EmployeeFormSections";

export function EmployeeForm({
  formData,
  setFormData,
  skills,
  technologies,
  toggleSkill,
  toggleTech,
  t,
  isSpanish,
  onSubmit,
  onCancel,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <EmployeeFormTabs
        formData={formData}
        setFormData={setFormData}
        skills={skills}
        technologies={technologies}
        toggleSkill={toggleSkill}
        toggleTech={toggleTech}
        t={t}
        isSpanish={isSpanish}
      />

      <FormActions
        cancelLabel={t("cancel")}
        submitLabel={t("save")}
        onCancel={onCancel}
        submitTestId="save-employee-btn"
      />
    </form>
  );
}

export default EmployeeForm;
